import * as keyapis_invoice_v1_invoice_pb from "./v1/keyapis_invoice_invoice_v1.pb";
import * as keyapis_invoice_v1_paymethod_pb from "./v1/keyapis_invoice_paymethod_v1.pb";

export default {
  v1: {
    resources: {
      invoice: keyapis_invoice_v1_invoice_pb,
      paymethod: keyapis_invoice_v1_paymethod_pb,
    },
  },
};
